import React, { useEffect, useState } from 'react'
import { useHistory } from "react-router-dom";
import {
  CURRENCY,
  RIELCURRENCY,
  US_RIEL_EXCHANGE
} from "../../helper/constant";
import {
    ItemInfo,
    Price,
    PriceEach,
    ItemInfoWrapper,
    ItemImageContainer,
    Items,
    CounterBox,
    CounterButton,
    DeleteButton,
    CounterValue
  } from "./CheckoutWithSidebar.style";
import * as constant from "../../constants/Constant";
import { Plus, Minus, CloseIcon } from "../../components/AllSvgIcon";
import t from "../../i18n/translate";
import { useCart } from '../../contexts/cart/use-cart';
import itemToCartService from '../../services/itemToCartService';
import expressService from '../../services/expressService';
import { Modal } from 'react-bootstrap';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';

const ItemSupplierClose = ({
  product, 
  props, 
  address_id, 
  modify_total, 
  cartType, 
  setWalletChecked, 
  setTotalWalletAmount, 
  walletChecked , 
  setPaymentMethod, 
  setUpdateOrder, 
  setRemoveProduct, 
  slotValidate
}) => {
    const { quantity, name, item_price } = product;
    const { carttotal, fetchOrderItems, removeItemFromCart } =
      useCart();
      const itemImageUrl = product.default_image_url;
    const [show, setShow] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [msg, setMsg] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [productQuantity, setProductQuantity] = useState(product.quantity)
  
    const history = useHistory()
    useEffect(() => {
      setUpdating(true);
      // props.fetchCart({ order_id: localStorage.getItem("order_id") });
      setProductQuantity(product.quantity)
    }, [product.quantity]);
  
  
    useEffect(() => {
      setUpdating(false);
      let user = localStorage.getItem("user");
      let parsedUser = JSON.parse(user);
      let cust_id = parsedUser.cust_id;
      modify_total();
      // if (
      //   localStorage.getItem("order_id") !== undefined &&
      //   (address_id !== undefined || true)
      //   ) {
      //   props.moveToCheckout({
      //     cust_id: cust_id,
      //     store_id: 1,
      //     order_id: localStorage.getItem("order_id"),
      //     address_id: selectDefaultAddress(),
      //     type: cartType === "express" ? 1 : 0,
      //   });
      //   console.log('check1,', selectDefaultAddress());
      // } 
      if( localStorage.getItem("order_id") === undefined ){
        alert(t("shop_checkout_order_not_exist", false));
      }
    }, [carttotal]);
  
    const handleRemoveProduct = async (e, product) => {
      e.preventDefault();
      e.stopPropagation();
  
      let response = window.confirm( t('home_basket_alert_remove_item', false))
      if(response){
        let tepTotal = carttotal-(product.item_price*product.quantity)
        setIsLoading(true);
        if (!localStorage.getItem("user")) {
          document.getElementById("joinBTn").click();
        } 
        else{
          await removeItemFromCart(product, cartType)
            .then(setUpdateOrder(true))
            .then(setRemoveProduct(true))
  
        }
  
        if(tepTotal< 10){
          if (cartType === "normal") {
            history.push("/");
          } else {
            history.push("/express");
          }
        }
        setIsLoading(false);
      }else{
        setProductQuantity(product.quantity)
      }
    }
  
    const handleDecQuantity = async (e, product) => {
      e.preventDefault();
      e.stopPropagation();
  
      setUpdating(true);
      setIsLoading(true);
      if (!localStorage.getItem("user")) {
        document.getElementById("joinBTn").click();
      }
      else {
        if(!isLoading) {
          let quantity = product.quantity;
  
          if(quantity > 1) {
            let body = {
              store_id: 1,
              item_id: product["item_id"],
              type: cartType === 'express' ? 1 : 0,
              quantity: quantity - 1
            };
            await handleSubmit(body);
            await fetchOrderItems(cartType, slotValidate);
            
          }
          // If quantity is 1
          else {
            setUpdating(false);
            handleRemoveProduct(e, product)
          }
  
          // if(carttotal - product.item_price < 10){
          //   if (cartType === "normal") {
          //     history.push("/");
          //   } else {
          //     history.push("/express");
          //   }
            // window.location.reload()
          // }
          setIsLoading(false);
        }
      }
    }
  
    const handleSubmit = async (body) => {
      const dataResp = await itemToCartService.updateQuantity(body);
      if (dataResp.status !== 200) {
        const pattern = ["multiSupplier", "paymentInProgress"];
        if (pattern.includes(dataResp.data.error)) {
          setMsg(true);
          if (!window.confirm(t('shop_checkout_update_cart_error_payment_in_progress'))) {
            setUpdating(false);
            return;
          };
          const orderLockResp = await expressService.orderLocked(cartType);
          if(orderLockResp.status === 200) {
            const response = await itemToCartService.updateQuantity(body);
            if (response.status === 200) {
              await fetchOrderItems(cartType, slotValidate);
            } else {
              alert(response.data.message);
            }
            setUpdating(false);
          } else {
            setUpdating(false);
            alert( t('shop_item_update_error') );
          }
        }
      } else {
        setUpdating(false);
        setUpdateOrder(true)
        if (walletChecked) {
          setPaymentMethod('cod');
          setWalletChecked(false);
          setTotalWalletAmount(props.wallet.amount);
        }
      }
    };

    const quantityFormDialog = async (e, product, newquantity) => {
        e.preventDefault();
        if(newquantity == product.quantity){
          return
        }
    
        setUpdating(true);
        if (parseInt(newquantity) >= 1) {
          let body = {
            store_id: 1,
            item_id: product["item_id"],
            type: cartType === "express" ? 1 : 0,
            quantity: newquantity,
          };
          await handleSubmit(body);
          await fetchOrderItems(cartType, slotValidate);
        }
        // If quantity is 1
        else {
          // setMsg(true);
          setUpdating(false);
          handleRemoveProduct(e, product)
        }
    };

    const handleCounterValueKeyDown = async (event, product, newquantity) =>{
        if(event.key === 'Enter'){
          quantityFormDialog(event, product, newquantity)
        }
    }

    const handleIncQuantity = async (e, product) => {
      e.preventDefault();
      e.stopPropagation();
  
      setUpdating(true);
      setIsLoading(true);
      if(!localStorage.getItem("user")){
        document.getElementById("joinBTn").click();
      }
      else {
        if(!isLoading) {
          let quantity = product.quantity;
  
          if(quantity >= 1) {
            let body = {
              store_id: 1,
              item_id: product["item_id"],
              type: cartType === 'express' ? 1 : 0,
              quantity: quantity + 1
            };
            await handleSubmit(body);
            await fetchOrderItems(cartType, slotValidate);
            setIsLoading(false);
          }
        }
      }
    }

    const dpEarnPromotions =
      product?.store_item_infos?.[0]?.dp_earn_promotions || product?.dp_earn_promotions || [];
    const activeDpPromotions = dpEarnPromotions.filter(
      (promo) => promo?.is_active && constant.compDate(promo.start_date, promo.end_date)
    );

    return (
        <Items>

          {/* model update items */}
          <Modal
            show={updating}
            onHide={() => {
              setUpdating(false);
            }}
            // dialogClassName="modal-lg"
            aria-labelledby="example-custom-modal-styling-title"
            size="sm"
            animation={true}
            centered
            backdrop="static"
          >
            {/* <Animation options={defaultOptions} height={180} width={180} /> */}
            <div
              style={{
                fontSize: 20,
                textAlign: "center",
                margin: 10,
                marginTop: 18,
                color: "#222",
              }}
            >
              {t("shop_checkout_update_cart")}
            </div>
          </Modal>
          <ItemImageContainer>
              <img
                  src={itemImageUrl ? itemImageUrl : require('../../assets/images/delishop-favicons.png') }
                  alt={name}
              />
          </ItemImageContainer>
          <div className="item-info">
              <div className="d-flex justify-content-start align-items-center">
                  <ItemInfoWrapper>
                      <div className="product_name" style={{ fontSize: "18px" }}>{name} </div>
                      <ItemInfo>
                          Sku {product.product_code}
                      </ItemInfo>
                  </ItemInfoWrapper>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                  <PriceEach >
                      <p className="d-flex align-items-end">
                          <div className="d-flex flex-column">
                              {product.promo === 1 && product.promo_start_date !== null && product.promo_end_date !== null && constant.compDate(product.promo_start_date, product.promo_end_date) ?
                                  <span className="original-price">{CURRENCY}{product.store_items_price_types[0].price.toFixed(2)} </span>
                                  : null
                              }
                              <span>{CURRENCY}{item_price.toFixed(2)} </span>
                          </div>
                          / Each
                      </p>
                  </PriceEach>
                  <div className="d-flex justify-content-between align-items-center">
                        <CounterBox>
                          <CounterButton className="minus circle" onClick={(e) => handleDecQuantity(e, product)}>
                              <Minus />
                          </CounterButton>
                          <CounterValue 
                          // min='1'
                          onChange={(e) => {
                              setProductQuantity(e.target.value);
                          }}
                          onBlur={(e)=>{
                              quantityFormDialog(e, product, e.target.value);
                          }}
                          onKeyDown={(e)=>{handleCounterValueKeyDown(e, product, e.target.value);
                          }}
                          value={productQuantity}
                          >
                          </CounterValue>
                            <CounterButton className="plus circle" onClick={(e) =>handleIncQuantity(e, product)}>
                              <Plus />
                          </CounterButton>
                      </CounterBox>
                      <DeleteButton onClick={(e) =>  handleRemoveProduct(e, product)}>
                        <DeleteOutlineIcon />
                      </DeleteButton>
                  </div>
                  <div className="d-flex flex-column">
                      <Price className="riel">
                          {Math.ceil((item_price * quantity) * US_RIEL_EXCHANGE)} {RIELCURRENCY}
                      </Price>
                      <Price className={`${cartType}`}>
                          <h5>
                              {CURRENCY}
                              {(item_price * quantity).toFixed(2)}
                          </h5>
                      </Price>
                  </div>
                  <div style={{ minWidth: "60px", display: "flex", justifyContent: "center" }}>
                    {activeDpPromotions.length > 0 && (
                      activeDpPromotions.map((promo, index) => (
                        <span key={promo.id || index} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                          <CardGiftcardIcon style={{ fontSize: "27px", color: "#545454ff" }} />
                          <span style={{ fontSize: "11px", fontWeight: 600, whiteSpace: "nowrap" }}>
                            {promo.points_multiplier
                              ? `+ ${Math.round((promo.points_multiplier - 1) * 100)}%`
                              : `+ ${promo.fixed_points}`
                            }
                          </span>
                        </span>
                      ))
                    )}
                  </div>
              </div>
          </div>
        </Items>
    )
}

export default ItemSupplierClose